<template>

    <div class="mb-3" :class="{'form-floating': floating}">

        <label v-if="label && floating === false" class="form-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <textarea 
            :id="id" 
            ref="input"
            v-bind="$attrs" 
            class="form-control" 
            :class="[ error ? 'is-invalid' : '', className ]" 
            :placeholder="floating && !placeholder ? translatedLabel : placeholder"
            :value="value" 
            @input="$emit('input', $event.target.value)" />

        <label v-if="label && floating" class="form-label" :for="id">
            {{ translatedLabel }}
        </label>

        <div v-if="error" class="invalid-feedback">{{ error }}</div>

    </div>

</template>

<style scoped>
    textarea.size-default {

    }
    textarea.size-medium {
        min-height: 150px;
    }
    textarea.size-large {
        min-height: 300px;
    }
</style>

<script>
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `textarea-input-${this._uid}`
                },
            },
            value: String,
            placeholder: {
                default: '',
            },
            floating: {
                default: false,
            },
            label: String,
            className: {
                default: '',
            },
            error: String,
            help: String,
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
        },
    }
</script>
